import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Maintenance configuration under ZTask Settings.
 * People: Permissions (TECHNICIAN / FLEET_MANAGER). Ops workbench: :3200.
 */
export default function MaintenanceSettingsPage() {
  const zMaint = process.env.REACT_APP_ZMAINTENANCE_URL || 'http://localhost:3200';

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Maintenance</h2>
      <p style={{ color: '#64748b', maxWidth: 640 }}>
        Configure people and access here. Ticket operations stay in the ZMaintenance workbench.
      </p>

      <section style={{ marginBottom: '1.5rem' }}>
        <h3>Roles</h3>
        <ul>
          <li>
            <strong>TECHNICIAN</strong> — field staff; <em>mobile app only</em> (web login blocked).
          </li>
          <li>
            <strong>FLEET_MANAGER</strong> — ops managers; <em>mobile + web</em> (ZMaintenance admin,
            reports).
          </li>
        </ul>
        <p>
          Assign via{' '}
          <Link to="/settings/permissions">Settings → Permissions</Link> (create/assign roles), then
          give Fleet Managers the <strong>ZMaintenance</strong> app under Assign Apps in ZTool.
        </p>
      </section>

      <section style={{ marginBottom: '1.5rem' }}>
        <h3>WorkBench</h3>
        <p>
          <a href={zMaint} target="_blank" rel="noreferrer">
            Open ZMaintenance admin
          </a>{' '}
          (Dashboard, Tickets, Checklists, Assets).
        </p>
      </section>

      <section>
        <h3>Reports</h3>
        <p>
          <Link to="/reports/maintenance">Reports → Maintenance</Link> for ticket status summaries.
        </p>
      </section>

      <section style={{ marginTop: '1.5rem' }}>
        <h3>Mobile clients</h3>
        <p style={{ color: '#64748b' }}>
          Mobile login must send header <code>X-Client: mobile</code> on <code>POST /login</code> (and
          OTP verify) so technicians are allowed. Web clients send <code>X-Client: web</code>.
        </p>
      </section>
    </div>
  );
}
